import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import Form from '@gef-ui/form-material/Form';

import { MPU_DISPLAY_TASK_STATISTIC } from 'features/common/acl/constants';
import formDescriptorFn, { TASK_STATISTICS_FORM_NAME } from 'features/views/taskStatistics/form';
import TaskStatistics, { Sidebar } from 'pages/TaskStatistics';

import PageLayout from '../components/PageLayout';

const TaskStatisticsPage = () => (
	<Form name={TASK_STATISTICS_FORM_NAME} formDescriptorFn={formDescriptorFn}>
		<PageLayout aside={<Sidebar />}>
			<div className="Page-main">
				<AccessControl accessLevel={MPU_DISPLAY_TASK_STATISTIC} showAccessDenied>
					<TaskStatistics />
				</AccessControl>
			</div>
		</PageLayout>
	</Form>
);

export default TaskStatisticsPage;
